import { useCallback, useContext } from 'react';
import { updateContext, identifyUser } from '@mindtickle/ui-shell-core/Datadog';

import { TLocalAuthContext } from '~/components/Auth';
import { TDataDogContext, DatadogContext } from '@mindtickle/ui-shell-core/DatadogProvider';
import { COMMON_TAGS, CONTEXT_NAMES, DEFAULT_OWNER_SCOPE } from '../config/constants';
import { getCompanyContext } from '../helpers';
import useDatadogHelpers from './useDatadogHelpers';
import useResourceFetchedType from './useResourceFetchedType';

const useDatadog = (auth?: TLocalAuthContext) => {
  const helpers = useDatadogHelpers();
  const datadog: TDataDogContext = useContext(DatadogContext);
  const { appNameVal, setAppName } = datadog;
  const { initializeResourceFetchFn } = useResourceFetchedType(datadog, appNameVal, updateContext);

  const initializeContext = useCallback(() => {
    updateContext(CONTEXT_NAMES.OWNER, DEFAULT_OWNER_SCOPE);
    if (auth?.user && auth?.company) {
      identifyUser(auth.user);
      updateContext(CONTEXT_NAMES.COMPANY, getCompanyContext(auth.company));
    }
  }, [auth?.company, auth?.user]);

  const resetApplicationContext = useCallback(() => {
    updateContext(CONTEXT_NAMES.OWNER, DEFAULT_OWNER_SCOPE);
  }, []);

  const resetApplicationLevelContext = useCallback(() => {
    updateContext(CONTEXT_NAMES.APP_LEVEL_DATA, {});
  }, []);

  const updateApplicationContext = useCallback((streamName, appName) => {
    updateContext(CONTEXT_NAMES.OWNER, {
      [COMMON_TAGS.STREAM_NAME]: streamName,
      [COMMON_TAGS.APP_NAME]: appName,
    });
    updateContext(CONTEXT_NAMES.SHELL, {
      [COMMON_TAGS.NETWORK]: navigator?.connection?.effectiveType || 'unknown',
    });
    // updateShellContext(COMMON_TAGS.NETWORK, navigator?.connection?.effectiveType || 'unknown');

    setAppName(appName);
    initializeResourceFetchFn();
  }, []);

  return {
    ...helpers,
    resetApplicationContext,
    initializeContext,
    updateApplicationContext,
    resetApplicationLevelContext,
  };
};

export default useDatadog;
